<router-outlet></router-outlet>







